<main>
  <kpmg-theme-loader></kpmg-theme-loader>
  <!-- TODO: Add signOut and SignIn Mechanism -->
  <!-- <sign-in [isCloud]="envSettings.azure.isCloud" [adalConfig]="adalConfig"></sign-in> -->
  <app-progress-indicator></app-progress-indicator>


  <div class="row content-wrapper w-100 p-0" *ngIf="isApplicationSetUp">
    <app-logout-prompt [isTimeOut]='alertUserLogOut'></app-logout-prompt>
    <div class="col-sm-auto pr-0">
      <app-client-shell></app-client-shell>
    </div>

    <div class="col-sm p-0 m-0">
      <app-top-header-panel></app-top-header-panel>

      <app-outage-message></app-outage-message>
      <div class="router-placeholder pl-3">
        <router-outlet (window:beforeunload)="appDestroyEvent()" (activate)="setAdminFlag()"></router-outlet>
        <!--<router-outlet (activate)="setAdminFlag()"></router-outlet>-->
      </div>
    </div>
  </div>

</main>
